import React, { useState, useEffect, useCallback } from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { getMyClients } from '~data/selectors/oauth';
import { myLoad, clientRemove } from '~data/actions/oauth';

import {
  Item,
  ItemIcon,
  ItemTitle,
  ItemInfo,
  ItemActions,
  Button,
} from '~ui';
import { Icon } from '~ui'
import { Confirm } from '~co/overlay/dialog';
import Edit from './edit';

export default function SettingsIntegrationsMy() {
  const clients = useSelector(getMyClients);
  const dispatch = useDispatch();
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    dispatch(myLoad());
  }, [dispatch]);

  const onEditClick = useCallback((e) => {
    e.preventDefault();
    setEdit(e.currentTarget.getAttribute('data-id'));
  }, []);

  const onCancelEdit = useCallback(() => setEdit(false), []);

  const onRemoveClick = useCallback(
    async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const _id = e.currentTarget.getAttribute('data-id');
      const name = e.currentTarget.getAttribute('data-name');

      if (
        await Confirm(t.s('areYouSure'), {
          ok: t.s('remove') + ' ' + name,
        })
      )
        dispatch(clientRemove(_id));
    },
    [dispatch],
  );

  if (!clients.length) return null;

  return (
    <>
      {clients.map(({ _id, name, description, icon }) => (
        <Item
          key={_id}
          as='a'
          href=''
          data-id={_id}
          onClick={onEditClick}
        >
          {icon && (
            <ItemIcon>
              <img src={icon} />
            </ItemIcon>
          )}
          <ItemTitle>{name}</ItemTitle>
          <ItemInfo>{description}</ItemInfo>
          <ItemActions>
            <Button
              variant='ghost'
              size='icon'
              data-id={_id}
              data-name={name}
              title={t.s('removeApp')}
              onClick={onRemoveClick}
            >
              <Icon name='trash' />
            </Button>
          </ItemActions>
        </Item>
      ))}

      {edit ? <Edit _id={edit} onClose={onCancelEdit} /> : null}
    </>
  );
}
